import { useAsync } from 'react-use';

import {
  discoveryApiRef,
  identityApiRef,
  useApi,
} from '@backstage/core-plugin-api';

export const useGetCategories = () => {
  const identityApi = useApi(identityApiRef);
  const discoveryApi = useApi(discoveryApiRef);

  const { value: categories, loading } = useAsync(async () => {
    try {
      const { token } = await identityApi.getCredentials();
      const endpointBase = await discoveryApi.getBaseUrl('watchtower');

      const response = await fetch(`${endpointBase}/categories`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await response.json();
      return data;
    } catch (e) {
      return [];
    }
  }, [identityApi, discoveryApi]);

  return { value: categories, loading };
};
